module.exports = __webpack_public_path__ + "static/img/dynamich1.baa7011.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamich1.png
// module id = eJjS
// module chunks = 45